/**
 * 1. events are fetched for whole month
 * 2. angular-ui calendar is responsible for displaying data
 */
angular
    .module('app.controllers')
    .controller(
        'DashboardPhaseCtrl',
        function (
            $scope,
            $timeout,
            $translate,
            $state,
            $log,
            $localStorage,
            uiCalendarConfig,
            api,
            notify,
            UserService,
            variables,
            usersOptions,
            groupsOptions,
            phaseStatusOptions
        ) {
            const vm = this;

            // @todo: cache for events
            vm.hash = 1;
            vm.eventSources = [[]];

            // dashboardType
            vm.type = $state.current.data.dashboardType || 'measurement';

            // settings
            const defaultSettings = (type) => ({
                date: moment(),
                author_id: [UserService.getUser().id.toString()],
                manager_id: [UserService.getUser().id.toString()],
                crew_id: [variables.defaults['crew_id_' + type]],
                status_id: [],
            });

            $localStorage.$default({
                dashboardPhases: {
                    measurement: defaultSettings('measurement'),
                    installation: defaultSettings('installation'),
                    transport: defaultSettings('transport'),
                    service: defaultSettings('service'),
                },
            });

            vm.userSettings = $localStorage.dashboardPhases[vm.type];
            vm.currentSettings = angular.copy(vm.userSettings);

            vm.usersOptions = usersOptions;
            vm.groupsOptions = groupsOptions;
            vm.phaseStatusOptions = phaseStatusOptions;

            vm.firstRender = true;

            vm.uiConfig = {
                calendar: {
                    header: {
                        left: 'chooseDate',
                        center: 'title',
                        right: 'month,listMonth,agendaWeek,listWeek,agendaDay prev,next',
                    },
                    buttonIcons: {
                        prev: 'md-left-single-arrow',
                        next: 'md-right-single-arrow',
                        prevYear: 'md-left-double-arrow',
                        nextYear: 'md-right-double-arrow',
                    },
                    customButtons: {
                        chooseDate: {
                            text: ' ',
                        },
                    },
                    buttonText: {
                        today: ' ',
                        month: ' ',
                        week: ' ',
                        day: ' ',
                    },
                    locale: 'pl',
                    aspectRatio: 2.1,
                    defaultDate: vm.userSettings.date || moment(),
                    selectable: true,
                    selectHelper: true,
                    select(start, end) {},
                    viewRender(view) {
                        $log.debug("Calendar's View Changed", view);
                        if (vm.firstRender) {
                            // podmiana ikony
                            $timeout(() => {
                                angular.element('.fc-chooseDate-button').html('<em class="material-icons md-24">date_range</em>');
                            });
                            // przechodzenie do wybranej daty
                            $timeout(() => {
                                const datepicker = UIkit.datepicker(angular.element('.fc-chooseDate-button .material-icons'));
                                datepicker.on('hide.uk.datepicker', () => {
                                    vm.goToDate(datepicker.current.format('YYYY-MM-DD'));
                                });
                            });
                        }

                        const typeMap = {
                            month: 'month',
                            agendaWeek: 'week',
                            agendaDay: 'day',
                        };

                        vm.timeUnit = typeMap[view.type] || 'month';
                        vm.viewStart = view.start;
                        vm.dateStart = view.start.format('YYYY-MM-DD');
                        vm.viewEnd = view.end;
                        vm.dateEnd = view.end.format('YYYY-MM-DD');

                        debouncedFetchEvents();

                        vm.firstRender = false;

                        if ('month' === view.name) {
                            // zapamiętujemy datę ze środka miesiąca, aby uniknać skakania
                            vm.userSettings.date = view.start.add(14, 'days').format('YYYY-MM-DD');
                        } else {
                            vm.userSettings.date = view.start.format('YYYY-MM-DD');
                        }
                    },
                    eventRender(event, element) {
                        element.attr('data-uk-tooltip', "{cls:'uk-tooltip long-text',pos:'bottom'}");
                        element.attr('title', event.tooltip);
                        element.find('.fc-list-item-title').append(`; ${$translate.instant('phases.time_of_service')}: ${event.desc}`);
                    },
                    editable: true,
                    eventLimit: true,
                    timeFormat: '(HH)(:mm)',
                },
            };

            const PhasesModel = api('phases');

            vm.timeSettings = null;
            vm.timeUnit = 'month';
            let eventDates = {};

            vm.recalculateUsage = () => {
                if (!vm.timeSettings) {
                    return false;
                }

                let calculated = 0;
                const viewRange = moment.range(vm.viewStart, vm.viewEnd);

                angular.forEach(eventDates[vm.hash], (event) => {
                    const range = moment.range(event.start, event.end);

                    if (viewRange.intersect(range)) {
                        calculated += event.time;
                    }
                });

                const multi = {
                    day: 1,
                    week: 5,
                    month: 22,
                };

                vm.time = {
                    available: vm.timeSettings.time * vm.timeSettings[vm.type] * multi[vm.timeUnit],
                    used: calculated,
                };
                vm.time.percent = Math.round((vm.time.used / vm.time.available) * 100);

                switch (true) {
                    case vm.time.percent > 80:
                        vm.time.cssClass = 'uk-progress-danger';
                        break;
                    case vm.time.percent > 50:
                        vm.time.cssClass = 'uk-progress-warning';
                        break;
                    default:
                        vm.time.cssClass = 'uk-progress-success';
                        break;
                }
            };

            vm.goToDate = (date) => {
                uiCalendarConfig.calendars['phasesCalendar'].fullCalendar('gotoDate', date);
            };

            vm.fetchEvents = () => {
                if (!_.isArray(vm.currentSettings.crew_id) || !vm.currentSettings.crew_id.length) {
                    return false;
                }

                const info = notify.info($translate.instant('loading'));
                notify.global(1);

                PhasesModel.stop()
                    .list({
                        pathSuffix: '/calendar',
                        data: {
                            type: vm.type,
                            crew_id: vm.currentSettings.crew_id,
                            author_id: vm.currentSettings.author_id,
                            manager_id: vm.currentSettings.manager_id,
                            status_id: vm.currentSettings.status_id,
                            from: vm.dateStart,
                            to: vm.dateEnd,
                        },
                    })
                    .then((response) => {
                        const phases = [];

                        if (null === vm.timeSettings) {
                            vm.timeSettings = response.data.workers;
                        }

                        const colorMap = {
                            measurement: '#ffa000',
                            installation: '#7cb342',
                            transport: '#2196f3',
                            service: '#e53935',
                        };

                        angular.forEach(response.data.events, (phase) => {
                            let time = 0;

                            if (0 < phase.time_recorded) {
                                time = parseFloat(phase.time_recorded);
                            } else if (0 < phase.time_needed) {
                                time = parseFloat(phase.time_needed);
                            } else if (0 < phase.time_calculated) {
                                time = parseFloat(phase.time_calculated);
                            }

                            phases.push({
                                id: phase.id,
                                title: `${phase.client_name} (${time}m / ${Math.round((100 * time) / 60) / 100}h)`,
                                desc: phase.time_of_service,
                                start: phase.date_from.substr(0, 10),
                                end: phase.date_to.substr(0, 10),
                                allDay: true,
                                url: `/phases/edit/${phase.id}`,
                                time,
                                color: colorMap[vm.type],
                                tooltip: [phase.client_name, ': ', phase.name, '<br>', phase.time_of_service || '-', ': ', phase.address || '-'].join(''),
                            });
                        });

                        $timeout(() => {
                            eventDates[vm.hash] = phases;
                            vm.eventSources[0] = eventDates[vm.hash];
                            vm.recalculateUsage();
                        }, 0);

                        $timeout(() => {
                            info.close();
                            notify.success($translate.instant('loaded'));
                            notify.global(0);
                        }, 500);
                    });
            };

            const debouncedFetchEvents = _.debounce(vm.fetchEvents, 750);
            $scope.$watch('DashboardPhase.currentSettings', debouncedFetchEvents, true);

            vm.rememberSettings = () => {
                vm.userSettings.crew_id = vm.currentSettings.crew_id;
                vm.userSettings.status_id = vm.currentSettings.status_id;
                vm.userSettings.author_id = vm.currentSettings.author_id;
                vm.userSettings.manager_id = vm.currentSettings.manager_id;
                $log.debug('saved settings', vm.userSettings);

                notify.info($translate.instant('saved'));
            };

            vm.resetSettings = () => {
                let settings = defaultSettings(vm.type);
                settings.date = vm.userSettings.date;

                vm.currentSettings = settings;
                $log.debug('reset settings', vm.currentSettings);

                notify.info($translate.instant('saved'));
            };
        }
    );
